import { api } from "@/api/axios.ts";
import { ApiSecuritySettings } from "@/types/security.types.ts";

export const securityApi = {
  getSecuritySettings: async function () {
    return api.get<ApiSecuritySettings>("/api/v1/settings/security");
  },
  updateSecuritySettings: async function (payload: ApiSecuritySettings) {
    return api.put<ApiSecuritySettings>("/api/v1/settings/security", payload);
  },
};
